//Juzgados de Paz.
export const MESA_DE_ENTRADA = 'MESA DE ENTRADA';
export const DESPACHO = 'DESPACHO';
export const FUNCIONARIO = 'FUNCIONARIO';

//Adminitracion General de Justicia

export const OPERADOR = 'OPERADOR';
export const ADMINISTRADOR = 'ADMINISTRADOR';

//Sistema (Para todos los organismos);

export const CONFIGURACION = 'CONFIGURACION';
export const SUPERVISOR = 'SUPERVISOR';

//DGJP

export const DGJP_DIRECTOR = 'DGJP_DIRECTOR';
export const DGJP_EMPLEADO = 'DGJP_EMPLEADO';

//GESTION HUMANA

export const GESTION_HUMANA = 'GESTION HUMANA';

export const ESTADISTICA = 'ESTADISTICA';

//SUELDOS
export const SUELDOS = 'SUELDOS';
